var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dismantle el-progress"},[_c('v-chart',{attrs:{"options":_vm.gaugeOption}}),(_vm.from !== 'otherPage')?_c('div',{staticClass:"text"},[_vm._v("设备在线率")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }